import styled from '@emotion/styled';

export const Container = styled.div`
  overflow-y: auto;
  .draft-editor {
    background-color: white;
    padding: 0 ${({ theme }) => theme.spacing(1)};
    border: 1px solid rgba(0, 0, 0, 0.06);
    &.content {
      min-height: 300px;
    }
  }
`;
